const ENCategoriesOccurences = {
	"Alterar categoria de ocorrência" : "Change occurrence category",
	"Categorias de Ocorrências" : "Occurrence categories",
	"Categorias de ocorrências" : "Occurrence categories",
	"Categoria de ocorrência adicionada com sucesso": "Occurrence category successfully added",
	"Categoria de ocorrência alterada com sucesso" : "Occurrence category successfully changed",
	"Categoria de ocorrência excluída com sucesso" : "Occurrence category successfully deleted",
	"Deseja realmente excluir a categoria de ocorrência" : "Do you really want to delete the occurrence category",
	"Descrição categoria de ocorrência é requerida": "Occurrence category description is required",
	"Erro ao carregar categoria": "Error loading category",
	"Erro ao excluir categoria de ocorrência" : "Error on deleting occurrence category",
	"Erro ao adicionar categoria de ocorrência": "Error adding occurrence category",
	"Erro ao alterar categoria de ocorrência" : "Error on changing occurrence category",
	"Etapas": "Steps",
	"Etapa": "Step",
	"Exclusão de categoria de ocorrência" : "Delete occurrence category",
	"Exibe análise": "Display analysis",
	"Inserção de categoria de ocorrência" : "Insert occurrence category",
	"Nova categoria de ocorrências" : "New occurrence category",
	"Utiliza": "Uses",
	"Usuário é requerido": "User is required",
	"Usuário responsavel é requerido": "Responsible user is required",
	"Usuário autoridade é requerido": "User authority is required"
};

export default ENCategoriesOccurences;

